// extracted by mini-css-extract-plugin
export default {"clickingOverviewContainer":"Steps_clickingOverviewContainer__0KioO","chartHeader":"Steps_chartHeader__w83it"};